<template>
  <validation-observer ref="obs">
    <v-container
      id="login"
      class="fill-height"
      tag="section"
    >
      <v-row justify="center">
        <v-slide-y-transition appear>
          <base-material-card
            color="success"
            light
            max-width="100%"
            width="400"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="display-2 font-weight-bold mb-2">
                  Register
                </h1>

                <v-btn
                  v-for="(social, i) in socials"
                  :key="i"
                  :href="social.href"
                  class="ma-1"
                  icon
                  rel="noopener"
                  target="_blank"
                >
                  <v-icon v-text="social.icon" />
                </v-btn>
              </div>
            </template>

            <v-card-text class="text-center">
              <div class="text-center grey--text body-1 font-weight-light">
                Or Be Classical
              </div>

              <validation-provider
                name="firstname"
                rules="required|max:10"
              >
                <v-text-field
                  v-model="user_form.firstname"
                  slot-scope="{errors,valid }"
                  color="secondary"
                  :error-messages="errors"
                  :success="valid"
                  label="First Name..."
                  prepend-icon="mdi-face"
                />
              </validation-provider>

              <validation-provider
                name="lastname"
                rules="required|max:10"
              >
                <v-text-field
                  v-model="user_form.lastname"
                  slot-scope="{errors,valid }"
                  color="secondary"
                  :error-messages="errors"
                  :success="valid"
                  label="Last Name..."
                  prepend-icon="mdi-face"
                />
              </validation-provider>

              <validation-provider
                ref="email"
                name="email"
                rules="required|email"
              >
                <v-text-field
                  v-model="user_form.email"
                  slot-scope="{errors,valid }"
                  color="secondary"
                  :error-messages="errors"
                  :success="valid"

                  label="Email..."
                  prepend-icon="mdi-email"
                />
              </validation-provider>

              <validation-provider
                name="password"
                rules="required"
              >
                <v-text-field
                  ref="password"
                  v-model="user_form.password"
                  slot-scope="{errors,valid }"
                  color="secondary"
                  :error-messages="errors"
                  :success="valid"
                  label="Password..."
                  type="password"
                  prepend-icon="mdi-lock-outline"
                />
              </validation-provider>

              <validation-provider
                name="confirmation"
                rules="required|password:confirmation"
              >
                <v-text-field
                  v-model="user_form.password_confirmation"
                  slot-scope="{errors, valid}"
                  class="mb-8"
                  color="secondary"
                  :error-messages="errors"
                  :success="valid"
                  label="Password Confirm..."
                  type="password"
                  prepend-icon="mdi-lock-outline"
                />
              </validation-provider>

              <v-checkbox
                :input-value="true"
                color="secondary"
              >
                <template v-slot:label>
                  <span class="text-no-wrap">I agree to the&nbsp;</span>

                  <a
                    class="secondary--text ml-6 ml-sm-0"
                    href="#"
                    @click.stop="dialog = true"
                  >
                    terms and conditions
                  </a>.
                  <v-dialog
                    v-model="dialog"
                    max-width="500"
                  >
                    <v-card>
                      <v-card-title class="headline">
                        Terms and conditions
                      </v-card-title>

                      <v-card-text>
                        What is Lorem Ipsum?
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                        the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley
                        of
                        type and scrambled it to make a type specimen book. It has survived not only five centuries, but
                        also the leap into electronic typesetting, remaining essentially unchanged. It was popularised
                        in
                        the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently
                        with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.

                        Why do we use it?
                        It is a long established fact that a reader will be distracted by the readable content of a page
                        when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal
                        distribution of letters, as opposed to using 'Content here, content here', making it look like
                        readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as
                        their default model text, and a search for 'lorem ipsum' will uncover many web sites still in
                        their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on
                        purpose (injected humour and the like).

                        Where does it come from?
                        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of
                        classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a
                        Latin
                        professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words,
                        consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical
                        literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and
                        1.10.33
                        of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC.
                        This book is a treatise on the theory of ethics, very popular during the Renaissance. The first
                        line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.

                        The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested.
                        Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum et Malorum" by Cicero are also reproduced
                        in
                        their exact original form, accompanied by English versions from the 1914 translation by H.
                        Rackham.
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />

                        <v-btn
                          color="green darken-1"
                          text
                          @click="dialog = false"
                        >
                          Ok
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>
              </v-checkbox>
              <pages-btn
                color="success"
                @click="signup"
              >
                Get Started
              </pages-btn>
              <br>
              <router-link to="/reset-password">
                Forgot Password
              </router-link>
            </v-card-text>
          </base-material-card>
        </v-slide-y-transition>
      </v-row>
    </v-container>
  </validation-observer>
</template>

<script>
  import {
    mapState,
    mapActions,
  } from 'vuex'
  import {
    ValidationObserver,
    ValidationProvider,
    // withValidation,
  } from 'vee-validate'

  export default {
    name: 'PagesRegister',
    inject: ['$validator'],
    components: {
      ValidationProvider,
      ValidationObserver,
      PagesBtn: () => import('./components/Btn'),

    },
    data: () => ({

      user_form: {
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        password_confirmation: '',
      },
      dialog: false,
      socials: [{
                  href: '#',
                  icon: 'mdi-facebook-box',
                },
                {
                  href: '#',
                  icon: 'mdi-twitter',
                },
                {
                  href: '#',
                  icon: 'mdi-github-box',
                },
      ],
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
      },
      validating: false,
    }),
    computed: mapState(['user']),

    mounted () {
      if (this.user.isLoggedIn) {
        this.$router.push('/admin/users')
      }
    },
    created () {
      this.$validator.extend('password', {
        validate: () => this.user_form.password === this.user_form.password_confirmation,
        getMessage () {
          return `The confirm password does not match`
        },
        params: [{
          name: 'confirmation',
          isTarget: true,
        }],
      })
    },

    methods: {
      ...mapActions(['doSingup']),
      async signup () {
        const result = await this.$refs.obs.validate()
        if (result) {
          this.doSingup(this.user_form).then(
            () => {
              this.$router.push('/')
            },
            error => {
              this.$refs.email.applyResult({
                errors: error.data.errors.email, // array of string errors
                valid: false, // boolean state
                failedRules: {}, // should be empty since this is a manual error.
              })
            }
          )
        }
      },

    },

  }

</script>
